import React, { useState } from "react";
import "./Register.css";
import { useNavigate } from "react-router-dom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import Conditions from "../../Components/Conditions/Conditions";
import Alert from "../../Components/Alert/Alert";
import PhoneInput from "../../Components/PhoneInput/PhoneInput";
import Axios from "axios";
import { useBaseUrl } from "../../ApiContext";

export default function Register() {
  const navigate = useNavigate();
  const baseUrl = useBaseUrl();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [userName, setUserName] = useState("");
  const [registerPhoneNumber, setRegisterPhoneNumber] = useState("");
  const [showConditions, setShowConditions] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [sendVerificationCode, setSendVerificationCode] = useState(false);

  const handlePhoneNumberChange = (event) => {
    setRegisterPhoneNumber(event.target.value);
  };

  const handlePhoneNumberKeyUp = (event) => {
    if (event.which !== 8) {
      if (registerPhoneNumber.length == 2 || registerPhoneNumber.length == 6) {
        setRegisterPhoneNumber((prevPhoneNumber) => prevPhoneNumber + " ");
      }
    }
  };

  const showConditionsHandler = () => {
    setShowConditions(true);
  };

  const hideConditionsHandler = () => {
    setShowConditions(false);
  };

  const clearUserLocalStorage = () => {
    localStorage.removeItem("age");
    localStorage.removeItem("weight");
    localStorage.removeItem("height");
    localStorage.removeItem("goal");
    localStorage.removeItem("activity");
  };

  const handleRegisterContinue = async () => {
    setSendVerificationCode(true);
    if (!isChecked) {
      setModalMessage("برای ادامه باید قوانین و مقررات را بپذیرید!");
    } else if (!firstName) {
      setModalMessage("نام نباید خالی باشد");
    } else if (!lastName) {
      setModalMessage("نام خانوادگی نباید خالی باشد");
    } else {
      setModalMessage("نام لاتین نباید خالی باشد");
    }
    if (!isChecked || !firstName || !lastName || !userName) {
      setShowModal(true);
      setTimeout(() => {
        setShowModal(false);
      }, 2000);
      return;
    }
    if (
      registerPhoneNumber.length === 11 &&
      isChecked &&
      firstName &&
      lastName &&
      userName
    ) {
      try {
        const response = await Axios.post(`${baseUrl}/check_number`, {
          username: `09${registerPhoneNumber.replace(/\s/g, "")}`,
          first_name: firstName,
          last_name: lastName,
          latin_name: userName,
        });
        const data = response.data;
        if (data.send_code) {
          localStorage.setItem(
            "userPhoneNumber",
            `09${registerPhoneNumber.replace(/\s/g, "")}`
          );
          clearUserLocalStorage();
          setShowModal(true);
          setModalMessage("در حال ارسال کد...");
          setTimeout(() => {
            setShowModal(false);
            navigate("/verificationCode", {
              state: { mobileNumber: registerPhoneNumber, wait: data.wait },
            });
          }, 2000);
        }
      } catch (error) {
        console.log("Error during posting signup data", error);
      }
    }
  };

  const acceptConditions = () => {
    setIsChecked(!isChecked);
    if (!isChecked) {
      setShowConditions(true);
    }
  };

  return showConditions ? (
    <Conditions onHide={hideConditionsHandler} />
  ) : (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="registerWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="registerTop">
            <h3 className="registerHeading">ثبت نام</h3>
            <form
              className="registerForm responsiveWidth"
              onSubmit={(e) => e.preventDefault()}
            >
              <label htmlFor="firstName">
                نام
                <input
                  className="registerInput"
                  id="firstName"
                  type="text"
                  placeholder="نام خود جهت ثبت نام"
                  value={firstName}
                  onChange={(event) => setFirstName(event.target.value)}
                />
              </label>
              <label htmlFor="lastName">
                نام خانوادگی
                <input
                  className="registerInput"
                  id="lastName"
                  type="text"
                  placeholder="نام خانوادگی خود جهت ثبت نام"
                  value={lastName}
                  onChange={(event) => setLastName(event.target.value)}
                />
              </label>
              <label htmlFor="username">
                نام به انگلیسی
                <input
                  className="registerInput"
                  id="username"
                  type="text"
                  placeholder="نام جهت اسفاده در اپلیکیشن"
                  value={userName}
                  onChange={(event) => setUserName(event.target.value)}
                />
              </label>
              <div className="registerPhoneNumber">
                <label htmlFor="phone">شماره همراه</label>
                <PhoneInput
                  sendVerificationCode={sendVerificationCode}
                  loginPhoneNumber={registerPhoneNumber}
                  onNumberChange={(event) => handlePhoneNumberChange(event)}
                  onNumberKeyUp={(event) => handlePhoneNumberKeyUp(event)}
                />
              </div>
              <label className="customRadioContainer">
                <input
                  type="checkbox"
                  className="radioBtn"
                  checked={isChecked}
                  onChange={acceptConditions}
                />
                <span className="customRadioBtn"></span>
                <div className="conditionText">
                  با ورود به رِدرُز شما
                  <span
                    className="conditionsLink"
                    onClick={showConditionsHandler}
                  >
                    شرایط و قوانین
                  </span>
                  استفاده از این برنامه را می‌پذیرید
                </div>
              </label>
            </form>
          </div>
          <button
            className="mainBtn registerBtn"
            onClick={handleRegisterContinue}
          >
            ادامه
          </button>
        </div>
        <Alert
          showAlert={showModal}
          alertText={modalMessage}
          bottom="5.3125rem"
        />
      </div>
    </div>
  );
}
